<form (ngSubmit)="onSubmit()" [formGroup]="group">
  @if (showButtonLabels()) {
    <ui-button
      [disabled]="addToShoppingButtonListDisabled()"
      (clicked)="addToShoppingListClicked.emit(this.group.value)"
      buttonStyle="outlined"
      type="button"
      icon="list"
    >
      Zur Einkaufsliste
    </ui-button>
  } @else if (showAddToShoppingList()) {
    <ui-icon-button
      [disabled]="addToShoppingButtonListDisabled()"
      (clicked)="addToShoppingListClicked.emit(this.group.value)"
      icon="list"
      type="button"
      buttonStyle="outlined"
    ></ui-icon-button>
  }

  @if (showQuantityCounter()) {
    <div class="wrapper-controls">
      <ui-form-quantity-counter
        [data]="dataQuantityCounter"
        [formControlName]="dataQuantityCounter.name"
        class="text-bold"
      ></ui-form-quantity-counter>
    </div>
  }

  @if (showButtonLabels()) {
    <ui-button
      [disabled]="orderButtonDisabled() || isAddToCartLoading()"
      [loading]="isAddToCartLoading()"
      type="submit"
      buttonStyle="filled"
      icon="cart-shopping"
      [class.success]="!orderButtonDisabled() && (inCartCount() > 0)"
      [badge]="inCartCountView()"
    >
      In den Warenkorb
    </ui-button>
  } @else {
    <ui-icon-button
      [disabled]="orderButtonDisabled() || isAddToCartLoading()"
      [loading]="isAddToCartLoading()"
      [class.success]="!orderButtonDisabled() && (inCartCount() > 0)"
      badgeSize="large"
      icon="cart-shopping"
      type="submit"
      buttonStyle="filled"
      [badge]="inCartCountView()"
    ></ui-icon-button>
  }
</form>
